export { MODULE_API } from '@/modules/sklad/constants';
export { DMS_MODULE } from '../constants';
export const NAME = 'NdObjednavkaUzaverka';
export const CRUMB_LABEL_KEY = 'setRyOUzav';
